import { ChangeCandidateDto } from 'src/app/data-transfer/entities/change-candidate-dto';
import { ImportTypeSetting, PackagingImportHelper } from './packaging-import-helper';
import { Observable } from 'rxjs';
import { ImportCandidateDto } from 'src/app/data-transfer/entities/import-candidate-dto';
import { ImportExportApiService } from 'src/app/data-transfer/services/import-export-api-service';
import { PackagingSystemNavigationService } from 'src/app/navigation/services/navigation-services/packaging-system-navigation.service';
import { ChangePackagingSystemCandidateDto } from 'src/app/data-transfer/entities/packaging-system-entities/change-packaging-system-candidate-dto';

export class PackagingSystemImportHelper implements PackagingImportHelper {
  constructor(
    private importExportApiService: ImportExportApiService,
    private packagingSystemNavigationService: PackagingSystemNavigationService
  ) {}

  getTableTitle(importType: ImportTypeSetting, archiveActive: boolean): string {
    if(archiveActive) {
        return 'dataManagement.import.import.tableTitlePackagingSystemArchive';
      }
    return 'dataManagement.import.changes.tableTitlePackagingSystem';
  }

  getDisplayedColumns(): string[] {
    return ['itemId', 'version', 'exportingOrganization', 'brandName', 'productName', 'articleNumber', 'timestamp', 'action', 'select'];
  }

  getPackagingImportCandidates(): Observable<ImportCandidateDto[]> {
    return this.importExportApiService.getPackagingSystemImportCandidates();
  }

  getPackagingChangeCandidates(): Observable<ChangeCandidateDto[]> {
    return this.importExportApiService.getPackagingSystemTrackedChanges();
  }

  packagingImportCandidatesSeen(): Promise<any> {
    return this.importExportApiService.putPackagingSystemsImportNotificationsSeen();
  }

  packagingChangeCandidatesSeen(): Promise<any> {
    return this.importExportApiService.putPackagingSystemsTrackingtNotificationsSeen();
  }

  packagingImportCandidatesCountUpdate(): Promise<any> {
    return Promise.all([this.importExportApiService.updatePackagingSystemImportCount(),this.importExportApiService.updatePackagingUnitImportCount(),this.importExportApiService.updateComponentImportCount(),this.importExportApiService.updateMaterialImportCount()]);
  }

  packagingChangeCandidatesCountUpdate(): Promise<any> {
    return Promise.all([this.importExportApiService.updatePackagingSystemTrackingCount(),this.importExportApiService.updatePackagingUnitTrackingCount(),this.importExportApiService.updateComponentTrackingCount(),this.importExportApiService.updateMaterialTrackingCount()]);
  }

  getDeleteFunction(importType: ImportTypeSetting): (candidate: number) => Observable<any> {
    if (importType === ImportTypeSetting.Import) {
      return this.getDeleteFunctionImportCandidate();
    }
    return this.getDeleteFunctionChangeCandidate();
  }

  getImportFunctionImportCandidate(): (candidateId: number, targetDirId: number, isWithTracking: boolean) => Observable<any> {
    return (candidateId: number, targetDirId: number, isWithTracking: boolean) => this.importExportApiService.importPackagingSystem(candidateId, targetDirId, isWithTracking);
  }

  getChangeFunctionChangeCandidate(): (changeId: number) => Observable<any> {
    return (changeId: number) => this.importExportApiService.applyPackagingSystemChanges(changeId);
  }

  getPackagingIdsFromChangeCandidates(selectedChanges: ChangeCandidateDto[]): number[] {
    return selectedChanges.map(x => (x as ChangePackagingSystemCandidateDto).existingPackagingSystem.id ?? -1).filter(x => x !== -1);
  }

  navigateToCandidate(candidate: ImportCandidateDto): void {
    this.packagingSystemNavigationService.navigateToPackagingSystemPreview(candidate.id);
  }

  navigateToChange(candidate: ChangeCandidateDto, seePackagingBeforeChange: boolean): void {
    const change = candidate as ChangePackagingSystemCandidateDto;
    const id = seePackagingBeforeChange ? change.existingPackagingSystem.id : change.importCandidateId;
    if (id == null) {
      return;
    }
    this.packagingSystemNavigationService.navigateToPackagingSystemPreview(id, true, seePackagingBeforeChange);
  }

  private getDeleteFunctionImportCandidate(): (candidate: number) => Observable<any> {
    return (candidateId: number) => this.importExportApiService.deletePackagingSystemImportCandidate(candidateId);
  }

  private getDeleteFunctionChangeCandidate(): (candidate: number) => Observable<any> {
    return (changeId: number) => this.importExportApiService.ignorePackagingSystemChanges(changeId);
  }
}
